import { SECTION_NAMES } from '@/config/widget';
import { derivedThemeValues } from '@/services/widgetTheme/derivedValues';
export const TENSION = 0;
const SOLID_LINE = [0, 0];
const DASHED_LINE = [5, 5];
export const CHART = derivedThemeValues(_ref => {
  let {
    theme,
    remCalc
  } = _ref;
  return {
    axis: {
      fontFamily: theme.typography.fontFamilyMono,
      fontSize: remCalc(14),
      fontColor: theme.color.gray600,
      fontWeight: 300,
      ticks: {
        padding: 10
      }
    },
    grid: {
      color: theme.color.border,
      borderWidth: 1,
      borderDash: SOLID_LINE,
      visible: true
    },
    gridSecondary: {
      visible: true,
      borderDash: DASHED_LINE
    },
    dataLabel: {
      color: theme.color.bodyFont,
      backgroundColor: theme.color.secondary
    },
    legend: {
      fontSize: remCalc(12)
    },
    point: {
      radius: 5
    },
    [SECTION_NAMES.lineChart]: {
      width: 2,
      dash: [0, 0],
      tension: TENSION,
      ticks: {
        padding: 16
      },
      point: {
        radius: 3,
        style: 'circle'
      },
      gradient: {
        start: 0.27,
        startOpacity: 0.1,
        stop: 0,
        stopOpacity: 0,
        transparency: 0.4
      }
    },
    areaLine: {
      width: 2,
      fill: 'fade'
    },
    [SECTION_NAMES.barChart]: {
      borderWidth: 0,
      percentage: 90,
      ticks: {
        padding: 16
      },
      category: {
        percentage: 80
      },
      radius: {
        topLeft: 0,
        topRight: 0,
        bottomLeft: 0,
        bottomRight: 0
      }
    },
    [SECTION_NAMES.pieDoughnut]: {
      arc: {
        borderWidth: 0
      },
      legend: {
        padding: 20,
        boxWidth: 10,
        boxHeight: 10,
        pointStyle: 'circle'
      },
      dataLabel: {
        fontSize: 20
      }
    },
    [SECTION_NAMES.gaugeChart]: {
      innerMargin: {
        top: 0.1,
        bottom: 0.0,
        left: 0.07,
        right: 0.07
      },
      arc: {
        width: 0.3,
        emptyColor: '#ebecf3'
      },
      pointer: {
        color: theme.color.gray800
      },
      title: {
        fontWeight: theme.base.fontRegular,
        fontSize: 32,
        color: theme.color.gray1000
      }
    },
    [SECTION_NAMES.radarChart]: {
      angleLine: {
        color: theme.color.gray200
      },
      line: {
        width: 2,
        lineDash: [0, 0]
      },
      point: {
        radius: 3
      },
      gradient: {
        startOpacity: 0.1,
        stop: 0,
        stopOpacity: 0
      },
      axis: {
        ticks: {
          visible: true
        }
      }
    }
  };
});